import SimpleGrid from '~/common/components/Grids/Grid/SimpleGrid';
import Text from '~/common/components/Texts/Text';
import { formatCurrency } from '~/common/util/format';

type QualifyingCalculationDataGridProps = {
  gridType: {
    isOneW2Grid?: boolean;
    isTwoW2Grid?: boolean;
    isPaystubGrid?: boolean;
    isVoeGrid?: boolean;
    incomeType?: string;
  };
  gridData: {
    yearToDate?: {
      fiscalYear?: number;
      monthlyIncome?: string;
      totalIncome?: string;
      backedIntoMonthlyIncome?: string;
    };
    lastYear?: {
      fiscalYear?: number;
      monthlyIncome?: string;
      totalIncome?: string;
      backedIntoMonthlyIncome?: string;
      w2Average?: string;
    };
    twoYearsAgo?: {
      fiscalYear?: number;
      monthlyIncome?: string;
      totalIncome?: string;
      backedIntoMonthlyIncome?: string;
      w2Average?: string;
    };
  };
};

export default function QualifyingCalculationDataGrid({
  gridType,
  gridData,
}: Readonly<QualifyingCalculationDataGridProps>) {
  if (gridType.isVoeGrid) {
    const { yearToDate, lastYear, twoYearsAgo } = gridData || {};
    return (
      <SimpleGrid columns={4}>
        <Text>&nbsp;</Text>
        <strong>{yearToDate?.fiscalYear}&#40;YTD&#41;</strong>
        <strong>{lastYear?.fiscalYear}</strong>
        <strong>{twoYearsAgo?.fiscalYear}</strong>
        <Text>Monthly</Text>
        <Text>{formatCurrency(yearToDate?.monthlyIncome)}</Text>
        <Text>{formatCurrency(lastYear?.monthlyIncome)}</Text>
        <Text>{formatCurrency(twoYearsAgo?.monthlyIncome)}</Text>
        <Text>Total</Text>
        <Text>{formatCurrency(yearToDate?.totalIncome)}</Text>
        <Text>{formatCurrency(lastYear?.totalIncome)}</Text>
        <Text>{formatCurrency(twoYearsAgo?.totalIncome)}</Text>
      </SimpleGrid>
    );
  }

  if (gridType.isPaystubGrid) {
    const { yearToDate } = gridData || {};
    return (
      <SimpleGrid columns={2}>
        <strong>Paystub&#40;{yearToDate?.fiscalYear}&#41;</strong>
        <strong>Year To Date</strong>
        <Text>Paystub Total</Text>
        <Text>{formatCurrency(yearToDate?.totalIncome)}</Text>
        <Text>Monthly</Text>
        <Text>{formatCurrency(yearToDate?.monthlyIncome)}</Text>
        <Text>{gridType.incomeType}</Text>
        <Text>{formatCurrency(yearToDate?.backedIntoMonthlyIncome)}</Text>
      </SimpleGrid>
    );
  }

  if (gridType.isOneW2Grid || gridType.isTwoW2Grid) {
    const { lastYear, twoYearsAgo } = gridData || {};
    return (
      <SimpleGrid columns={gridType.isOneW2Grid ? 2 : 3}>
        <strong>W2</strong>
        <strong>{lastYear?.fiscalYear}</strong>
        {gridType.isTwoW2Grid && <strong>{twoYearsAgo?.fiscalYear}</strong>}
        <Text>W2 Total</Text>
        <Text>{formatCurrency(lastYear?.totalIncome)}</Text>
        {gridType.isTwoW2Grid && (
          <Text>{formatCurrency(twoYearsAgo?.totalIncome)}</Text>
        )}
        <Text>Monthly</Text>
        <Text>{formatCurrency(lastYear?.w2Average)}</Text>
        {gridType.isTwoW2Grid && (
          <Text>{formatCurrency(twoYearsAgo?.w2Average)}</Text>
        )}
        <Text>{gridType.incomeType}</Text>
        <Text>{formatCurrency(lastYear?.backedIntoMonthlyIncome)}</Text>
        {gridType.isTwoW2Grid && (
          <Text>{formatCurrency(twoYearsAgo?.backedIntoMonthlyIncome)}</Text>
        )}
      </SimpleGrid>
    );
  }

  return null;
}
